var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-alert',{staticClass:"acs-base-empty-list mx-4",attrs:{"dense":"","outlined":"","color":"grey","value":_vm.value}},[_c('v-icon',{attrs:{"size":"80","color":_vm.colour}},[_vm._v("\n    mdi-format-list-checkbox\n  ")]),_c('br'),_vm._v("\n  "+_vm._s(_vm.text)+"\n")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }